const messages = {
  bonus: {
    title: "Panoramica crediti bonus",
    description: "I bonus in euro vengono assegnati alle aziende partecipanti in base ai dati di vendita inviati.",
    lastMonth: "Mese scorso",
    currentMonth: "Mese corrente",
    totalCurrentYear: "Totale anno corrente",
    totalLastYear: "Totale anno scorso",
  },
  points: {
    title: "Panoramica crediti punti",
    period: "Anno civile in corso ({year})",
    totalAwarded: "Totale punti assegnati",
    redeemed: "Punti riscattati",
    totalBalance: "Saldo totale punti",
    redemptionRate: "Punti riscattati come percentuale dei punti assegnati",
    averageAwarded: "Media dei punti assegnati per pneumatico acquistato",
    standardAwarded: "Punti netti dalle righe di vendita calcolate, resi inclusi",
    bsPlusInclBooster: "Punti dalle righe di vendita con quantità positiva",
    perTire: "Punti riscattati per pneumatico acquistato",
  },
  tires: {
    title: "Panoramica quantità pneumatici",
    description: "Pneumatici acquistati dai clienti",
    prevMonth: "Mese precedente",
    totalLastYear: "Totale anno scorso",
    purchaseIndirect: "Acquisto tramite grossista (indiretto)",
    purchaseDirect: "Acquisto tramite grossista (diretto)",
    totalCurrentYear: "Totale anno corrente",
    currentMonth: "Mese corrente",
  },
  participating: {
    title: "Panoramica clienti partecipanti",
    description: "Le aziende che si registrano a BRIDGESTONE PLUS possono essere associate tramite il numero cliente.",
    total: "Totale",
    newThisMonth: "Nuovi questo mese",
    newThisYear: "Nuovi quest'anno",
    createdInCurrentMonth: "Creati nel mese corrente (dall'amministratore)",
    loginsCurrentYear: "Accessi nell'anno corrente (dopo l'accettazione dei termini)",
  },
  brand: {
    title: "Marchio",
    description: "I tuoi acquisti nel dettaglio",
    centerTitle: "Per\nmarchio",
  },
  rim: {
    title: "Cerchio",
    centerTitle: "Per misura\ncerchio",
  },
  tireGoals: {
    title: "Obiettivi pneumatici",
    subtitle: "Guadagna punti per i tuoi acquisti di pneumatici.",
    centerTitle: "Per misura\npneumatico",
    tiresRemaining: "Pneumatici rimanenti",
    progressionTarget: "Obiettivo di avanzamento: ",
    pointsEarnedPurchases: "punti guadagnati\n" + "con i tuoi\n" + "acquisti",
    pointsEarnedBoosters: "punti guadagnati\n" + "con i\n" + "booster",
    purchasesDetail: "I tuoi acquisti nel dettaglio",
    cta: "Scopri di più sui tuoi punti",
    pointsTitle: "I tuoi punti",
    pointsSubtitle: "Punti guadagnati sui tuoi acquisti Bridgestone",
    achievementsTitle: "I tuoi risultati",
    achievementsSubtitle: "Il tuo impegno annuale:",
    achievementsSubtitle2: "pneumatici",
  },
  score: {
    title: "Punteggio",
    total: "Totale",
    credits: "Crediti in",
    deductions: "Detrazioni in",
        unlockedPoints: "Punti sbloccati",
        pendingPoints: "Punti in sospeso",
  },
  score_extended: {
    title1: "Saldo punti",
    title2: "Bonus in euro",
    balance: "Saldo punti",
    bonus_in_euro: "Bonus in euro",
    date: "Data",
    added_points: "Punti aggiunti in",
    total_bands: "Totale marchi",
    goal: "Obiettivo",
    tyres_previous_year: "Pneumatici venduti l'anno scorso",
    tyres_current_year: "Pneumatici venduti quest'anno",
    target_this_year: "Obiettivo di vendita di quest'anno",
    bonus_this_year: "Bonus guadagnato (€)",
    loyal_minimum: "Livello minimo di fedeltà",
    bonus_multiplier: "Tasso moltiplicatore bonus",
  },
  lastImport: {
    label: "Ultima importazione dei dati di vendita:",
    on: "il",
  },
  wholesalerTable: {
    title: "Clienti partecipanti nel dettaglio",
    description: "Di seguito trovi le aziende registrate su BRIDGESTONE PLUS con il numero cliente della tua azienda. Puoi usare i filtri per un ordinamento diverso o la ricerca per trovare i clienti.",
    columns: {
      customer_number: "N. cliente",
      address_company_name: "Azienda",
      address_street: "Via e numero civico",
      address_postal_code: "CAP",
      address_city: "Città",
      last_registration: "Ultima registrazione",
      network: "Rete",
      profile_group: "Gruppo",
      tires_amount: "Quantità pneumatici",
      point_balance: "Saldo punti",
      bonus: "Bonus",
      details: "Dettagli",
    },
    searchPlaceholder: "Cerca",
  },
  dealerTable: {
    columns: {
      date: "Data",
      wholesaler_bs_plus: "Grossista BS+",
      customer_number: "Numero cliente",
      article: "Articolo",
      brand: "Marchio",
      product: "Prodotto",
      type: "Tipo",
      inch: "Pollici",
      season: "Stagione",
      amount: "Quantità",
      points: "Punti",
      activity: "Attività",
      total_points: "Punti totali",
    },
    title: "Tabella dealer",
    description: "Panoramica delle attività dealer",
  },
  business_units: {
    title: "Business unit",
    centerTitle: "Per\nunità",
  },
  season: {
    title: "Stagione",
    centerTitle: "Per periodo\ndell'anno",
  },
};

export default {
  messages,
};
